import { PeopleCostCentreDto } from "./people-cost-centre.dto";
import { PeopleDepartmentDto } from "./people-department.dto";
import { PeopleMerchantDto } from "./people-merchant.dto";

export class PeopleBudgetDto {
    id?: number;
    merchantId?: number;
    departmentId?: number;
    costCentreId?: number;
    weekNoStartDate?: string;
    budgetAmount?: number | string;
    merchantGroupId?: number;
    weekNo?: number;
    year?: number;
    changeStatus?: 'create' | 'update' | 'delete';
    createdDate?: Date;
    modifiedDate?: Date;
    lastModifiedUserId?: number;
    version?: number;

    department?: PeopleDepartmentDto;
    merchant?: PeopleMerchantDto;
    costCentre?: PeopleCostCentreDto;
}

export interface PeopleBudgetQueryDto extends PeopleBudgetDto {
    year?: number;
    merchantId?: number;
}